import { Component } from 'react'
import * as styles from 'styles/molecules/forms/Form.css'
import { Field, reduxForm } from 'redux-form'
import { ReduxFormProps } from 'interfaces/component'
import schema from 'schemas/passwordChangeSchema'
import { asyncValidator } from 'helpers/schemaHelpers'
import { getSaveButtonFormProps, shouldAsyncValidate } from 'helpers/formHelpers'
import { FORM_PASSWORD_CHANGE } from 'constants/forms'
import PasswordFieldContainer from 'components/features/pfm/PasswordField/PasswordFieldContainer'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import ButtonRow from 'components/atoms/buttons/ButtonRow'
import { ButtonStyle } from 'components/features/pfm/Button/Button'
import { FIELD_CONFIRM_PASSWORD_PROPS } from 'constants/fields'

export type PasswordChangeFormProps = ReduxFormProps & {
  onCancel: () => void
}

@reduxForm({
  form: FORM_PASSWORD_CHANGE,
  asyncValidate: asyncValidator(schema),
  shouldAsyncValidate,
})
class PasswordChangeFormComponent extends Component<PasswordChangeFormProps, {}> {
  render () {
    const { handleSubmit, onCancel } = this.props

    return (
      <form className={ styles.form } onSubmit={ handleSubmit } data-qa-marker='password-change-form'>
        <ul>
          <li className={ styles.item }>
            <Field
              name='current_password'
              component={ TextFieldWrapped }
              props={{
                label: 'Old Password',
                type: 'password',
                autoFocus: true,
                qaMarker: 'old-password',
              }}
            />
          </li>
          <li className={ styles.item }>
            <PasswordFieldContainer
              name='new_password'
              label='New Password'
            />
          </li>
          <li className={ styles.item }>
            <Field
              name='password_confirm'
              component={ TextFieldWrapped }
              props={ FIELD_CONFIRM_PASSWORD_PROPS }
            />
          </li>
          <li className={ styles.item }>
            <ButtonRow
              size='small'
              buttons={ [
                { text: 'Save', submit: true, ...getSaveButtonFormProps(this.props) },
                { text: 'Cancel', style: 'hollow' as ButtonStyle, onClick: onCancel, qaMarker: 'cancel-button' },
              ] }
            />
          </li>
        </ul>
      </form>
    )
  }
}

export default PasswordChangeFormComponent
